import React, { useState } from "react";
import PrimaryButton from "../../widgets/Button/PrimaryButton";
import Dialog from "../../widgets/Dialog/Dialog";
import Card from "../../widgets/Card/Card";
import LockIcon from "../../assets/icons/LockIcon";
import OrderPackagesDetails from "./OrderPackagesDetails";
import { formatPhoneWithOptionalIsd } from "../../utils/commonUtils";
import { formatMonetaryAmount } from "../../utils/formatMonetaryAmount";

import styles from "./OrderDetails.module.scss";

const OrdersDetails = (props) => {
  const {
    order,
    onConfirmPayment,
    isCreatingPaymentOrder,
  } = props;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const currencyCode = order.currency;
  const packages = Array.isArray(order.packages) ? order.packages : [];

  return (
    <div className={styles.pageContainer}>
      <div className={styles.gridContainer}>
        <div className={`${styles.sectionBlock} ${styles.personalSection}`}>
          <h3 className={styles.sectionTitle}>Billing details</h3>
          <Card>
            <div className={styles.row}>
              <span className={styles.label}>Name</span>
              <span className={styles.value}>{order.recipient_name}</span>
            </div>
            <div className={styles.row}>
              <span className={styles.label}>Phone No.</span>
              <span className={styles.value}>
                {formatPhoneWithOptionalIsd(
                  order.recipient_masked_phone_number,
                  order.isd_code,
                )}
              </span>
            </div>
          </Card>
        </div>

        <OrderPackagesDetails
          packages={packages}
          className={styles.orderDetailsSection}
        />

        <div className={`${styles.sectionBlock} ${styles.paymentSummarySection}`}>
          <h3 className={styles.sectionTitle}>Payment summary</h3>
          <Card>
            <div className={styles.row}>
              <span className={styles.label}>Order Amount</span>
              <span className={styles.value}>
                {formatMonetaryAmount(order.order_amount, currencyCode)}
              </span>
            </div>
            <div className={styles.row}>
              <span className={styles.label}>Remaining Amount</span>
              <span className={styles.value}>
                {formatMonetaryAmount(order.remaining_amount, currencyCode)}
              </span>
            </div>
            <div className={`${styles.row} ${styles.highlightRow}`}>
              <span className={styles.labelStrong}>Amount to pay now</span>
              <span className={styles.valueStrong}>
                {formatMonetaryAmount(order.payment_amount, currencyCode)}
              </span>
            </div>
          </Card>
        </div>
      </div>

      <div className={styles.footerButton}>
        <PrimaryButton
          startIcon={<LockIcon />}
          onClick={() => setIsDialogOpen(true)}
        >
          Proceed to Pay
        </PrimaryButton>
      </div>

      <Dialog
        isOpen={isDialogOpen}
        handleOnClose={() => setIsDialogOpen(false)}
      >
        <div className={styles.dialogContainer}>
          <h3 className={styles.dialogTitle}>Proceeding to payment</h3>
          <p className={styles.dialogMessage}>
            Do not press the back button while payment is in progress
          </p>
          <div className={styles.dialogActions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={() => setIsDialogOpen(false)}
            >
              Cancel
            </button>
            <PrimaryButton
              onClick={onConfirmPayment}
              disabled={isCreatingPaymentOrder}
            >
              {isCreatingPaymentOrder ? "Confirming..." : "Confirm"}
            </PrimaryButton>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default OrdersDetails;
